import { render, staticRenderFns } from "./SetUPPackages.vue?vue&type=template&id=37dd91f4&scoped=true&"
import script from "./SetUPPackages.vue?vue&type=script&lang=js&"
export * from "./SetUPPackages.vue?vue&type=script&lang=js&"
import style0 from "./SetUPPackages.vue?vue&type=style&index=0&id=37dd91f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dd91f4",
  null
  
)

export default component.exports